import Vue from 'vue'
import VueRouter from 'vue-router'
// import store from '../store'

import UserLogin from '../components/user/UserLogin.vue'
import ClientLogin from '../components/user/ClientLogin.vue'
import Dashboard from '../components/admin/Dashboard.vue'
import Calendar from '../components/admin/Calendar.vue'
import Clients from '../components/admin/Clients.vue'
import Settings from '../components/admin/Settings.vue'
import ClientDashboard from '../components/client/ClientDashboard.vue'
import Estimation from '../components/admin/Estimation.vue'
// import ClientCheckDraftImage from '../components/client/ClientCheckDraftImage.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    components: {
      default: UserLogin
    }
  },
  {
    path: '/about',
    name: 'About',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
  },
  {
    path: '/user/login',
    name: 'UserLogin',
    component: UserLogin
  },
  {
    path: '/dashboard',
    name: 'Dashboard',
    component: Dashboard
  },
  {
    path: '/dashboard/calendar',
    name: 'Calendar',
    component: Calendar
  },
  {
    path: '/dashboard/clients',
    name: 'Clients',
    component: Clients
  },
  {
    path: '/dashboard/settings',
    name: 'Settings',
    component: Settings
  },
  {
    path: '/dashboard/estimation',
    name: 'Estimation',
    component: Estimation
  },
  {
    path: '/client/login/',
    name: 'ClientLoginWarning',
    component: ClientLogin
  },
  {
    path: '/client/login/:clientCode',
    name: 'ClientLogin',
    component: ClientLogin
  },
  {
    path: '/client/login/:clientCode/:orderId',
    name: 'ClientLoginWithOrderId',
    component: ClientLogin
  },
  {
    path: '/client/dashboard/',
    name: 'ClientDashboardWarning',
    component: ClientDashboard
  },
  {
    path: '/client/dashboard/:clientCode',
    name: 'ClientDashboard',
    component: ClientDashboard
  },
  {
    path: '/client/dashboard/:clientCode/:orderId',
    name: 'ClientCheckDraftImage',
    component: ClientDashboard
  },

]

const router = new VueRouter({
  // mode: 'history',
  // base: process.env.BASE_URL,
  base: '/',
  routes
})

// router.beforeEach((to, from, next) => {
//   const hasToken = store.getters.getAccessToken
// // alert(hasToken)
//   if(!hasToken){
//     next('/user/login')
//   }else{
//     next()
//   }
// })

export default router
